module.exports = __webpack_public_path__ + "img/logo.39a4b4ed.png";